import { useState, useEffect } from 'react';

/**
 * Hook to get media query values based on the current window size
 *
 * @returns {Object} Object with media query values
 */
const useMediaQuery = () => {
  const [currentSize, setCurrentSize] = useState<'mobile' | 'tablet' | 'desktop'>('desktop');

  useEffect(() => {
    const MOBILE_MAX_WIDTH = 767;
    const TABLET_MAX_WIDTH = 1023;

    const updateSize = () => {
      const width = window.innerWidth;
      if (width <= MOBILE_MAX_WIDTH) {
        setCurrentSize('mobile');
      } else if (width <= TABLET_MAX_WIDTH) {
        setCurrentSize('tablet');
      } else {
        setCurrentSize('desktop');
      }
    };

    const resizeObserver = new ResizeObserver(() => {
      updateSize();
    });

    resizeObserver.observe(document.documentElement);

    updateSize();

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return {
    isMobile: currentSize === 'mobile',
    isTablet: currentSize === 'tablet',
    isMobileOrTablet: currentSize === 'mobile' || currentSize === 'tablet',
    isDesktop: currentSize === 'desktop',
  };
};

export default useMediaQuery;
